export default __webpack_public_path__ + "static/media/photo--lg--rambo-2.0e2016c9.jpg";